import IC_COLLECTOR_FAIL from "@/assets/common/ic_collect_fail.svg?react";

export interface IAudioPermissionDeniedProps {}

const AudioPermissionDenied: React.FC<IAudioPermissionDeniedProps> = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <IC_COLLECTOR_FAIL className="w-12 h-12" />
      <div className="mt-6 font-600 text-size-4.5 text-mx-secondary">
        <span className="font-400"> 应用无麦克风权限，请开启权限后重试</span>
      </div>
    </div>
  );
};

export default AudioPermissionDenied;
